import { render, staticRenderFns } from "./TemporaryTerms.vue?vue&type=template&id=0650617b&scoped=true"
import script from "./TemporaryTerms.vue?vue&type=script&lang=js"
export * from "./TemporaryTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650617b",
  null
  
)

export default component.exports